import 'regenerator-runtime/runtime'
import React from 'react'
import ReactDOM from 'react-dom'

import { GlobalStyles } from 'config'

import { initializeDatadog, initializeDatadogRum } from 'config/analytics'
import createEnvironment from 'config/env'
import { initializeSentryClient } from 'config/sentry'

import { APP_ID } from 'app-constants'
import theme from 'theme'
import createBackendClient from 'utils/backend'
import { setVisitorId } from 'utils/setVisitorId'

import Application from './application'

import { AnalyticsClientProvider, useAnalyticsClient } from '@acorns/web-utils'
import { AcornsHelloTogglesProvider } from './providers/AcornsHelloTogglesProvider/index'

const App = () => {
  window.analytics = useAnalyticsClient()

  return (
    <>
      <GlobalStyles />
      <AcornsHelloTogglesProvider>
        <Application
          appId={APP_ID}
          backend={backendClient}
          environment={environment}
          theme={theme}
        />
      </AcornsHelloTogglesProvider>
    </>
  )
}

setVisitorId()

const environment = createEnvironment()

initializeSentryClient(environment)
initializeDatadog(environment.get('datadogKey'))
initializeDatadogRum({
  applicationId: environment.get('datadogRumApplicationId'),
  clientToken: environment.get('datadogRumClientToken'),
  service: environment.get('service'),
  env: environment.get('stage'),
})

const backendClient = createBackendClient(environment.get('backend'))

ReactDOM.render(
  <AnalyticsClientProvider
    rudderStack={{
      dataPlaneUrl: environment.get('rudderStackDataPlaneUrl'),
      writeKey: environment.get('rudderStackWriteKey'),
    }}
    sessionReplayProps={{
      enabled: true,
      sampleRate: 1.0,
    }}
    amplitudeAPIKey={environment.get('amplitudeApiKey')}
  >
    <App />
  </AnalyticsClientProvider>,
  document.getElementById('app'),
)
